import React, { useState, useEffect, useRef } from "react";
import { motion } from "motion/react";
import { useNavigate, useLocation } from "react-router-dom";
import QuitModal from "../../common/Modal/QuitModal";
import { ReactComponent as PathfinderLogoWhite } from "../../../assets/images/Pathifnder Logo_White.svg";
import Notify from "../../../assets/icons/notify.svg";
import { App, Auth } from "../../../routes/Constants";
import {
  handleCatch,
  prescriberName,
  redirectToHomepageDependingOnUser,
} from "../../../shared/helpers";
import APIVariables from "../../../services/api-variables";
import useRoles from "../../../hooks/useRoles";
import LocalStorage from "../../../shared/localStorage";
import Axios from "../../../services/Axios";
import MenuNotifications from "./MenuNotifications";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

const topMenuShellClass = "fixed top-0 z-[3] w-full font-sans";
const mainBarClass = "flex h-[50px] w-full bg-[#00567A]";
const mainInnerClass =
  "mx-auto flex h-full w-full items-center justify-around px-10";
const authClass = "ml-auto flex items-center gap-5";
const authLinkClass = "text-white no-underline hover:underline";
const menuItemClass =
  "w-full cursor-pointer border-0 bg-transparent p-2.5 text-left text-base font-normal leading-5 text-[#505050] hover:bg-[#f8f8f8]";
const menuNavItemClass =
  "cursor-pointer p-2.5 text-base font-normal leading-5 text-[#505050] hover:bg-[#f8f8f8]";

const TopMenu = ({ loggedInInitials }) => {
  const reducedMotion = usePrefersReducedMotion();
  const [quitModalIsOpen, setIsOpenQuit] = useState(false);
  const {
    isPrescriber,
    isPharmacy,
    isConnectedNurse,
    isCustomerSolution,
    isHomecare,
    isOutpatient,
    isPrimaryPharmacist,
    storageData,
  } = useRoles();
  const navigate = useNavigate();
  const location = useLocation();
  const [clickedOutsideMenu, setClickedOutsideMenu] = useState(true);
  const menuRef = useRef();
  function closeModalQuit() {
    setIsOpenQuit(false);
  }
  const [countNotifications, setCountNotifications] = useState(0);

  function quitModal() {
    // fix for prevent loop when click on home logo when you are on a public page and you are allready loggedin in another tab (you have token alredy)
    window.location.href = redirectToHomepage;
    closeModalQuit();
  }
  const [clickedOutsideNotification, setClickedOutsideNotification] =
    useState(true);
  const notificationRef = useRef();

  useEffect(() => {
    if (
      storageData?.isLoggedIn &&
      (isPrescriber ||
        isPharmacy ||
        isConnectedNurse ||
        isHomecare ||
        isOutpatient)
    ) {
      getCountNotifications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener("fetchNotificationsCount", () =>
      getCountNotifications()
    );
    return () => document.removeEventListener("fetchNotificationsCount", {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCountNotifications = async () => {
    try {
      let res = await Axios.get(
        APIVariables.PRESCRIPTIONS_NOTIFICATIONS_COUNT
      ).catch((error) => {
        handleCatch(error);
      });
      if (res?.status === 200) {
        setCountNotifications(res?.data);
      }
    } catch (error) { }
  };

  const redirect = (URL) => {
    const ID =
      storageData?.registration_number ||
      storageData?.pharmacy?.registration_number;

    if (URL === App.PROFILE_DEFAULT) {
      navigate(App.PROFILE_DEFAULT + ID);
    } else {
      navigate(URL);
      setClickedOutsideNotification(true);
    }
  };

  const signOut = async () => {
    Axios.get(APIVariables.USERS_LOGOUT)
      .then(() => {
        localStorage.removeItem(LocalStorage.USER_NHSPORTAL);
        window.location.href = Auth.LOGIN;
      })
      .catch(() => {
        localStorage.removeItem(LocalStorage.USER_NHSPORTAL);
        window.location.href = Auth.LOGIN;
      });
  };

  const handleClickOutsideMenu = (e) => {
    if (e.target.className === "user-credentials") {
      setClickedOutsideMenu(!clickedOutsideMenu);
      setClickedOutsideNotification(true);
    } else if (!!menuRef.current) {
      setTimeout(() => {
        setClickedOutsideMenu(true);
      }, 300);
      if (!menuRef.current?.contains(e.target)) {
        setClickedOutsideMenu(true);
      }
    }
  };

  const handleClickOutsideNotification = (e) => {
    const notificationsClickableClasses = [
      "wrapper-icon-notify",
      "icon-click-notify",
      "notification-number",
    ];
    if (notificationsClickableClasses.includes(e.target.className)) {
      setClickedOutsideNotification(!clickedOutsideNotification);
      setClickedOutsideMenu(true);
    } else if (!!notificationRef.current) {
      if (!notificationRef.current?.contains(e.target)) {
        setClickedOutsideNotification(true);
        if (e.target.className === "user-credentials") {
          setClickedOutsideMenu(!clickedOutsideMenu);
        }
      } else if (Boolean(e.target.closest(".wrapper-notifications-modal"))) {
        // Do not close the modal if click inside modal
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideNotification);
    document.addEventListener("mousedown", handleClickOutsideMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideNotification);
      document.removeEventListener("mousedown", handleClickOutsideMenu);
    };
  });

  const checkRoutes = () => {
    const routesToShow = [
      Auth.REGISTER,
      App.ADD_NURSE,
      App.PROFILE_DEFAULT,
      App.DEFAULT_EDIT_NURSE,
      App.PATIENT_INITIATION,
      App.PRESCRIPTION_AUTHORISATION_FORM_DEFAULT,
      App.PAF_RENEW_DEFAULT,
    ];

    if (routesToShow.some((path) => location.pathname.includes(path))) {
      const isEditMode = localStorage.getItem(
        LocalStorage.IS_EDIT_MODE_NHSPORTAL
      );

      if (
        !!isEditMode &&
        (location.pathname.includes(App.PROFILE_DEFAULT) ||
          location.pathname.includes(App.DEFAULT_EDIT_NURSE))
      ) {
        setIsOpenQuit(true);
      } else if (
        !isEditMode &&
        (location.pathname.includes(App.PROFILE_DEFAULT) ||
          location.pathname.includes(App.DEFAULT_EDIT_NURSE))
      ) {
        quitModal();
      } else if (location.pathname.includes(App.PAF_RENEW_DEFAULT)) {
        setIsOpenQuit(true);
      } else if (
        location.pathname.includes(App.PRESCRIPTION_AUTHORISATION_FORM_DEFAULT)
      ) {
        if (isPharmacy) {
          const isSubmitted =
            !!document.getElementsByClassName("approve-reject-paf")[0];

          if (isSubmitted) {
            setIsOpenQuit(true);
          } else {
            quitModal();
          }
        } else {
          quitModal();
        }
      } else {
        setIsOpenQuit(true);
      }
    } else {
      quitModal();
    }
  };

  const redirectToHomepage = redirectToHomepageDependingOnUser(
    storageData?.user_type
  );

  const redirectNotificationToPAFDetails = (patientID, formID) => {
    if (isPharmacy || isHomecare || isOutpatient) {
      navigate(
        App.PRESCRIPTION_AUTHORISATION_FORM_DEFAULT +
        `${patientID}` +
        "/" +
        `${formID}`
      );
      setClickedOutsideNotification(true);
    }
  };

  const navSpring = reducedMotion
    ? { duration: 0 }
    : { duration: 0.5, type: "spring", stiffness: 100, damping: 20 };

  return (
    <div className={topMenuShellClass}>
      <motion.div
        className={mainBarClass}
        initial={reducedMotion ? false : { y: -100 }}
        animate={{ y: 0 }}
        transition={navSpring}
      >
        <div className={mainInnerClass}>
          <motion.div
            className="flex cursor-pointer items-center"
            onClick={checkRoutes}
            title="Go to Homepage"
            initial={reducedMotion ? false : { opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: reducedMotion ? 0 : 0.05 }}
            whileHover={reducedMotion ? {} : { scale: 1.05 }}
          >
            <PathfinderLogoWhite
              className="block h-5 w-auto max-w-[186px] sm:h-6"
              aria-label="PATHFINDER"
              role="img"
            />
          </motion.div>
          {!storageData?.isLoggedIn ? (
            <div className={authClass}>
              <motion.a
                href="/login?register=1"
                className={authLinkClass}
                initial={reducedMotion ? false : { opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: reducedMotion ? 0 : 0.1 }}
                whileHover={reducedMotion ? {} : { scale: 1.05 }}
              >
                Register
              </motion.a>
              <motion.a
                href="/login"
                className={authLinkClass}
                initial={reducedMotion ? false : { opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: reducedMotion ? 0 : 0.2 }}
                whileHover={reducedMotion ? {} : { scale: 1.05 }}
              >
                Login
              </motion.a>
            </div>
          ) : (
            <div className={authClass}>
              {/* {isPrescriber && (
                <a href={App.PATIENT_INITIATION} title="Refer a Patient">
                  <img src={AddNew} alt="Add New" />
                </a>
              )} */}

              {(isPrescriber ||
                isPharmacy ||
                isConnectedNurse ||
                isHomecare ||
                isOutpatient) && (
                  <React.Fragment>
                    <div className="relative">
                      <motion.div
                        className="wrapper-icon-notify relative cursor-pointer"
                        title="Notifications"
                        initial={reducedMotion ? false : { opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: reducedMotion ? 0 : 0.4 }}
                        whileHover={reducedMotion ? {} : { scale: 1.1 }}
                      >
                        <img
                          src={Notify}
                          alt="Notify"
                          className="icon-click-notify mr-2.5 cursor-pointer"
                        />

                        {countNotifications?.notification_count > 0 && (
                          <motion.span
                            className="notification-number absolute -top-1.5 right-0 min-w-[15px] rounded-[10px] bg-[#fb3449] px-0.5 text-center text-xs font-medium leading-[15px] text-white"
                            animate={
                              reducedMotion
                                ? { scale: 1 }
                                : { scale: [1, 1.2, 1] }
                            }
                            transition={{
                              duration: 2,
                              repeat: reducedMotion ? 0 : Infinity,
                              repeatType: "loop",
                            }}
                          >
                            {countNotifications?.notification_count}
                          </motion.span>
                        )}
                      </motion.div>
                      {clickedOutsideNotification === false && (
                        <div
                          className="wrapper-notifications-modal absolute top-[37px] left-[-147px] z-1 w-80 bg-white p-5 shadow-[0_0_40px_rgba(0,0,0,0.2)]"
                          ref={notificationRef}
                        >
                          {(countNotifications.latest_notifications || []).map(
                            (notification, indexNotification) => (
                              <MenuNotifications
                                key={indexNotification}
                                redirectNotificationToPAFDetails={
                                  redirectNotificationToPAFDetails
                                }
                                notification={notification}
                              />
                            )
                          )}
                          <hr className="border-[#f8f8f8] opacity-100" />
                          <div className="[&>div]:flex [&>div]:cursor-pointer [&>div]:justify-start [&>div]:pl-2 [&>div]:text-base [&>div]:leading-[19px] [&>div]:text-[#00567a] hover:[&>div]:text-[#00567A]">
                            <div onClick={() => redirect(App.NOTIFICATIONS)}>
                              View All Notifications
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                )}

              <div className="relative" title="Menu">
                <span className="user-credentials ml-1.5 flex h-[25px] w-[25px] cursor-pointer items-center justify-center rounded-xl bg-white text-[#00567a]">
                  {loggedInInitials?.toString()?.toUpperCase()}
                </span>

                {clickedOutsideMenu === false && (
                  <div
                    className="absolute top-10 left-[37%] z-[1] min-w-[170px] w-max -translate-x-[37%] bg-white shadow-[0_0_40px_rgba(0,0,0,0.2)]"
                    ref={menuRef}
                  >
                    {(isPrescriber ||
                      isPharmacy ||
                      isConnectedNurse ||
                      isHomecare ||
                      isOutpatient) && (
                        <button
                          type="button"
                          className={menuItemClass}
                          onClick={() => redirect(App.PROFILE_DEFAULT)}
                        >
                          {prescriberName()}
                          <div className="pb-0 pl-0.5 text-sm font-normal leading-5 text-[#8c8c8c]">
                            View Profile
                          </div>
                        </button>
                      )}
                    {isPrescriber && (
                      <div
                        className={menuNavItemClass}
                        onClick={() => redirect(App.NURSES)}
                      >
                        Connected Nurses
                      </div>
                    )}
                    {(isPharmacy || isHomecare || isOutpatient) &&
                      isPrimaryPharmacist && (
                        <div
                          className={menuNavItemClass}
                          onClick={() => redirect(App.CONNECTED_PHARMACISTS)}
                        >
                          Connected Pharmacist
                        </div>
                      )}
                    {isPharmacy && (
                      <div
                        className={menuNavItemClass}
                        onClick={() => redirect(App.CONNECTED_OUTPATIENT)}
                      >
                        Connected Outpatient
                      </div>
                    )}
                    {isPharmacy && (
                      <div
                        className={menuNavItemClass}
                        onClick={() => redirect(App.HOMECARE)}
                      >
                        Connected Homecare
                      </div>
                    )}
                    {(isPrescriber ||
                      isPharmacy ||
                      isConnectedNurse ||
                      isHomecare ||
                      isOutpatient) && (
                        <div
                          className={menuNavItemClass}
                          onClick={() => redirect(App.PATIENT_MATERIALS)}
                        >
                          HCP & Patient Material
                        </div>
                      )}
                    {(isPrescriber ||
                      isPharmacy ||
                      isConnectedNurse ||
                      isHomecare ||
                      isOutpatient) && (
                        <div
                          className={menuNavItemClass}
                          onClick={() => redirect(App.REPORT_EVENT)}
                        >
                          Report an AE/Pregnancy
                        </div>
                      )}
                    {isCustomerSolution && (
                      <div
                        className={menuNavItemClass}
                        onClick={() => redirect(App.PHARMACY_LIST)}
                      >
                        Registered Pharmacy Listing
                      </div>
                    )}
                    {!isCustomerSolution && (
                      <div
                        className={menuNavItemClass}
                        onClick={() => redirect(App.CONTACT_US)}
                      >
                        Contact Us
                      </div>
                    )}
                    <button
                      type="button"
                      className={menuItemClass}
                      onClick={() => signOut()}
                    >
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </motion.div>
      {/* <div className="logo">
        <div className="main-max-width">
          <motion.img
            src={LoginBackground}
            alt="Pathfider Portal Logo"
            onClick={checkRoutes}
            title="Go to Homepage"
            whileHover={
              reducedMotion
                ? {}
                : { scale: 1.05, filter: "brightness(0.95)" }
            }
            transition={{ duration: 0.2 }}
            style={{ cursor: "pointer" }}
          />
          {storageData?.isLoggedIn && !isCustomerSolution ? (
            <React.Fragment>
              <motion.div
                className="find-patient"
                ref={searchRef}
                initial={
                  reducedMotion ? false : { opacity: 0, x: 20 }
                }
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: reducedMotion ? 0 : 0.5 }}
                whileHover={reducedMotion ? {} : { scale: 1.02 }}
              >
                <div className="wrapper-search-input">
                  <form autoComplete="off">
                    <input
                      className="input-search-general"
                      value={filterValue}
                      onChange={onChangeSearchValue}
                      onKeyDown={onKeyDownSearch}
                      placeholder="Find a Patient..."
                      autoComplete="search-patient"
                    />
                  </form>
                  <button
                    type="button"
                    className="search"
                    onClick={() => {
                      if (filterValue.trim().length > 0) {
                        navigate(`/view-patients?search=${encodeURIComponent(filterValue)}`);
                        setClickedOutsideSearch(true);
                      }
                    }}
                  >
                    <img src={SearchIcon} alt="Search" />
                  </button>
                </div>
                {patients.length &&
                  filterValue.length > 0 &&
                  clickedOutsideSearch === false ? (
                  <div className="wrapper-tooltip-patients">
                    {patients.slice(0, 3).map((patient, indexPatient) => (
                      <SearchPatientMap
                        redirectToPatient={redirectToPatient}
                        patient={patient}
                        key={indexPatient}
                        isPrescriber={isPrescriber}
                        displayDetails={displayDetails}
                      />
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </motion.div>
            </React.Fragment>
          ) : (
            <div></div>
          )}
        </div>
      </div> */}
      <QuitModal
        quitModalIsOpen={quitModalIsOpen}
        closeModalQuit={closeModalQuit}
        quitModal={quitModal}
        description="Are you sure you want to cancel filling out this Form. All progress will be lost and you will need to start again."
      />
    </div>
  );
};
export default TopMenu;
